// CallbackComponent.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CallbackComponent = () => {
    const navigate = useNavigate();
  useEffect(() => {
    // Extract code from query string
    const code = new URLSearchParams(window.location.search).get('code');

    console.log('Authorization Code:', code);
    if (code) {

       navigate('/provider/accountsetting')
    } else {
      console.warn('No authorization code found.');
    }
  }, []);

  return <p>Redirecting...</p>;
};

export default CallbackComponent;
